import styled from "styled-components";

export const ContainerDashboard = styled.section`
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    div.Dashboard__filter {
        margin-top: -10px;
        background: #fff;
        display: flex;
        align-self: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding: 10px;
        border-radius: 15px;
        /* min-width: 65%; */
        position: sticky;
        top: 0px;
        z-index: 999;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
    }

    div.Dashboard__progress {
        width: 100%;
        display: flex;
        gap: 10px;
    }

    div.Dashboard__three {
        width: 100%;
        height: calc(100vh - 430px);
        display: flex;
        gap: 10px;
    }    

`;